import {Component, Input, OnInit} from '@angular/core';
import {appointmentLinkVerificationCodes} from '@shared/constants/appointment.constants';
import {configVariableValues} from '@shared/constants/config-variable-values.constants';
import {AppConfigService} from '@shared/services/app-config.service';
import {LinkPatientService} from '@shared/services/link-patient.service';

@Component({
  selector: 'si-link-patient-warning',
  templateUrl: './link-patient-warning.component.html',
  styleUrls: ['./link-patient-warning.component.scss']
})
export class LinkPatientWarningComponent implements OnInit {
  @Input() styleClass: string;
  showWarning: boolean;
  linkPatientVerification = 0;
  hasSmsVerification: boolean;
  hasEmailVerification: boolean;

  constructor(
    private linkPatientService: LinkPatientService,
    private appConfigService: AppConfigService
  ) {
  }

  ngOnInit(): void {
    this.showWarning = this.linkPatientService.getShowLinkPatientWarning();
    this.hasSmsVerification = this.appConfigService.getVariableValue(configVariableValues.DOUBLE_FACTOR_AUTH_METHOD) === appointmentLinkVerificationCodes.SMS;
    this.hasEmailVerification = this.appConfigService.getVariableValue(configVariableValues.DOUBLE_FACTOR_AUTH_METHOD) === appointmentLinkVerificationCodes.EMAIL;
  }

  onClickCloseIcon(): void {
    this.hideWarning();
  }

  hideWarning(): void {
    this.showWarning = false;
    this.linkPatientService.setShowLinkPatientWarning(false);
  }

  onClickVerifyIdentity(): void {
    this.linkPatientVerification += 1;
  }

  onFinishVerification(): void {
    this.hideWarning();
  }
}
